<template>
	<Card class="location-card" :highlights="exactMatch">
		<template #content>
			<div class="location-card__main">
				<div class="location-card__icon">
					<i class="icon icon-location" />
				</div>
				<span class="location-card__number">
					({{ location.locationNumber }})
				</span>

				<Ellipsis
					:data="displayLocationName"
					:textToHighlight="$route.query.search"
					class="location-card__name"
				></Ellipsis>
			</div>
		</template>
		<template #actions>
			<ActionsSet class="location-card__actions" :options="actions" />
		</template>
	</Card>
</template>

<script>
import Card from '@/components/shells/card/card';
import ActionsSet from '@/site-components/actions-set/actions-set';
import Ellipsis from '@/components/visual/ellipsis';

// mixins
import CustomerCardActions from '@/mixins/customers/customer-card-action';

// utils
import { createTextValueObj } from '@/utils/object';

export default {
	name: 'LocationCard',
	components: {
		Card,
		ActionsSet,
		Ellipsis
	},
	mixins: [CustomerCardActions],
	props: {
		location: {
			type: Object,
			default: () => {}
		},
		customer: Object
	},
	computed: {
		displayLocationName() {
			return createTextValueObj(
				this.location.locationName,
				this.$route.query.search
			);
		},
		exactMatch() {
			return (
				this.$route.query.search &&
				this.location.locationName === this.$route.query.search
			);
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Location Card
    * Can use SCSS variables = TRUE
 */
.location-card {
	width: calc(100% + 36px); // Extra width to match the mock card alignment

	&__main {
		display: flex;
		align-items: center;
		height: 100%;
		gap: $gutter-md;
	}

	.icon-location {
		font-size: 18px;
	}

	&__name {
		@include body-text('regular-emphasis');
	}
}
</style>
